import * as _ from 'lodash';

const EntidadRules  = (data = {}, ruleData = {}) => {
  let AmbitoRule = 'string';

  if (!_.isEmpty(ruleData.TipoProceso) && _.isEqual(ruleData.TipoProceso, 'Ordinario')) {
    AmbitoRule = 'required';
  }

  if (!_.isEmpty(ruleData.TipoComite) && _.isEqual(ruleData.TipoComite, 'Ejecutivo Estatal')) {
    AmbitoRule = 'string';
  }

  if (!_.isEmpty(ruleData.TipoComite) && _.isEqual(ruleData.TipoComite, 'Directivo Estatal')) {
    AmbitoRule = 'string';
  }

  if (!_.isEmpty(ruleData.TipoProceso) && _.isEqual(ruleData.TipoProceso, 'Campaña')) {
    AmbitoRule = 'required';
  }

  if (!_.isEmpty(ruleData.TipoProceso) && _.isEqual(ruleData.TipoProceso, 'Precampaña')) {
    AmbitoRule = 'required';
  }

  return {
    ClaveEntidad: [
      'required',
    ],
    Ambito: [
      AmbitoRule,
      'string',
      'in:Local,Federal',
    ]
  }
};

export default EntidadRules;
